import React from "react";

const Prices = () => {
    return (
        <div className="Prices">
            <div className="column-one">Prices page added!</div>
        </div>
    );
};

export default Prices;
